import { LocaleCodes } from '@_/static';
import { getClosestLocale } from '@_/utils';

export async function loadI18nMessages(
  locale: string,
  fallbackLocale: string
): Promise<Record<string, string>> {
  const resolvedLocale = getClosestLocale(locale, LocaleCodes) || fallbackLocale;

  const { language } = new Intl.Locale(resolvedLocale);

  if (language === 'en') {
    return (await import('../../translations/en.json')).default;
  } else {
    return (await import('../../translations/zh-HK.json')).default;
  }
}
